import React, { Component } from 'react';
import tmp1 from './tmp1.jpg';
import instruction1 from './instruction1.jpg';
import instruction2 from './instruction2.jpg';
import instruction3 from './instruction3.jpg';
import instruction4 from './instruction4.jpg';
import Collapse from "@kunukn/react-collapse";
import Fade from './Fade.js';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';


export class CreatePageTelegramIntegration extends React.Component {

    state = {
        instructionsShow : false
    }
    constructor(props) {
        super(props);
        this.ref1 = React.createRef();
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        this.setState({ instructionsShow: !this.state.instructionsShow });
    }
    render() {
        return (
            <div className='createPage_whiteBlock'>
                

                <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Интеграция с Telegram
                            </div>
                        </div>
                <div className='whiteBlockMiddle'>
                     {/*<div className='inputTextLabel'>
                        Пожалуйста введите название канала (Начинается с @)    
                    </div>
                    <input type='text' placeholder="@название_канала" />
                        */}

                    <div className='whiteBlockText' >
                        Теперь, пожалуйста, добавьте своего бота    
                        в администраторы вашего канала. <span className='blue'> Мы гарантируем, что бот будет использоваться только для проверки
                        подписок. </span> Подробнее в гайде.
                    </div>
                        {/* 
                        <div onClick={this.handleClick} className="instructionsShow" >
                            Инструкция <svg  className={this.state.instructionsShow ? "icon" : "icon icon--expanded"} viewBox="6 0 12 24">
      <path d="M8 0L6 1.8 14.4 12 6 22.2 8 24 18 12z"></path>
    </svg>

                        </div>
                        <Collapse isOpen={this.state.instructionsShow} >
                    <ul className='instructions'  style={{ marginTop: '30px'}}>
                        <li>
                            1. Зайдите в информацию о вашем канале
                            <img src={instruction1}/>
                        </li>

                        

                        <li>
                            2. Добавьте нашего бота <span className='red'>@checkiffollows_bot</span> в ваш канал
                            <img src={instruction2}/>
                        </li>

                        <li>
                            3. Бота необходимо сделать администратором - не бойтесь этого
                            <img src={instruction3}/>
                        </li>

                        <li>
                            4. <span className='red'>Во избежание любых проблем с ботом ставьте минимальные права!</span>
                            <img src={instruction4}/>
                        </li>


                    </ul>
                    </Collapse>
 
                        */}
                       

                    <div className="whiteBlockButtonBlock"  >
                        <a onClick={(e) => {
                                this.props.CheckIntegration(e)
                                
                                
                        }
                        } className="whiteBlockButton" href='#'>Проверить интеграцию</a>
                    </div>  
                </div>
                
    </div>           

            
            
        )
    }
}